<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/settings']">Zur Konfiguration</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS <cds-icon shape="two-way-arrows"></cds-icon> Konfiguration <cds-icon shape="two-way-arrows"></cds-icon> Mitarbeiter</h2>

  <div class="card">
    <div class="card-header">Mitarbeiterverwaltung</div>
    <div class="card-block">
      <div class="card-text">
        <form [formGroup]="staffForm" class="clr-form-control">
          <clr-datagrid [clrDgLoading]="loading">
            <clr-dg-column [clrDgField]="'staff_id'" [clrDgSortOrder]="descSort">ID</clr-dg-column>
            <clr-dg-column [clrDgField]="'firstname'">Vorname</clr-dg-column>
            <clr-dg-column [clrDgField]="'lastname'">Nachname</clr-dg-column>
            <clr-dg-column [clrDgField]="'email'">E-Mail</clr-dg-column>
            <clr-dg-column [clrDgField]="'phone'">Telefon</clr-dg-column>
            <clr-dg-column [clrDgField]="'pps_id'">PPS-ID</clr-dg-column>
            <clr-dg-column [clrDgField]="'crm_id'">CRM-ID</clr-dg-column>
            <clr-dg-column>CRM-Username</clr-dg-column>
            <clr-dg-column [clrDgField]="'is_admin'">Admin</clr-dg-column>
            <clr-dg-column [clrDgField]="'active'">Aktiv</clr-dg-column>
            <clr-dg-column>Aktion</clr-dg-column>

            <clr-dg-placeholder>
              <div class="datagrid-placeholder">
                <cds-icon shape="info-circle" aria-hidden="true" style="margin-right:8px"></cds-icon>
                <span>Keine Mitarbeiter gefunden</span>
              </div>
            </clr-dg-placeholder>

            <clr-dg-row *clrDgItems="let item of staff; index as i">
              <clr-dg-cell>{{ item.staff_id }}</clr-dg-cell>
              <clr-dg-cell>{{ item.firstname }}</clr-dg-cell>
              <clr-dg-cell>{{ item.lastname }}</clr-dg-cell>
              <clr-dg-cell>{{ item.email }}</clr-dg-cell>
              <clr-dg-cell>{{ item.phone }}</clr-dg-cell>
              <clr-dg-cell>{{ item.pps_id || '-' }}</clr-dg-cell>
              <clr-dg-cell>{{ item.crm_id || '-' }}</clr-dg-cell>
              <clr-dg-cell>{{ authUsersByStaffId[item.staff_id]?.crm_username || '-' }}</clr-dg-cell>
              <clr-dg-cell>{{ item.is_admin ? 'ja' : 'nein' }}</clr-dg-cell>
              <clr-dg-cell>{{ item.active ? 'ja' : 'nein' }}</clr-dg-cell>
              <clr-dg-cell class="btn-group btn-primary btn-icon">
                <button *ngIf="!updating && isAdmin" class="btn btn-sm" (click)="updateMode(i, item.staff_id)" title="Ändern">
                  <cds-icon shape="pencil"></cds-icon>
                  <span class="clr-icon-title">Ändern</span>
                </button>
                <button *ngIf="isAdmin" class="btn btn-warning btn-sm" (click)="deleteStaff(item.staff_id, item.firstname + ' ' + item.lastname)" title="Deaktivieren">
                  <cds-icon shape="times"></cds-icon>
                  <span class="clr-icon-title">Deaktivieren</span>
                </button>
              </clr-dg-cell>
            </clr-dg-row>

            <clr-dg-row *ngIf="editMode && !updating && isAdmin">
              <clr-dg-cell>-</clr-dg-cell>
              <clr-dg-cell><input class="clr-input" formControlName="firstname" placeholder="Vorname"></clr-dg-cell>
              <clr-dg-cell><input class="clr-input" formControlName="lastname" placeholder="Nachname"></clr-dg-cell>
              <clr-dg-cell><input class="clr-input" formControlName="email" placeholder="E-Mail"></clr-dg-cell>
              <clr-dg-cell><input class="clr-input" formControlName="phone" placeholder="Telefon"></clr-dg-cell>
              <clr-dg-cell><input class="clr-input" formControlName="pps_id" placeholder="PPS-ID"></clr-dg-cell>
              <clr-dg-cell><input class="clr-input" formControlName="crm_id" placeholder="CRM-ID"></clr-dg-cell>
              <clr-dg-cell><input class="clr-input" formControlName="crm_username" placeholder="z.B. t.lerche"></clr-dg-cell>
              <clr-dg-cell>
                <select class="clr-input" formControlName="is_admin">
                  <option [ngValue]="true">ja</option>
                  <option [ngValue]="false">nein</option>
                </select>
              </clr-dg-cell>
              <clr-dg-cell>
                <select class="clr-input" formControlName="active">
                  <option [ngValue]="true">ja</option>
                  <option [ngValue]="false">nein</option>
                </select>
              </clr-dg-cell>
              <clr-dg-cell class="btn-group btn-primary btn-icon">
                <input class="clr-input" style="margin-right:8px; width: 200px;" formControlName="auth_password" placeholder="Initial-Passwort">
                <button class="btn btn-sm" (click)="addStaff()" [disabled]="staffForm.invalid">
                  <cds-icon shape="floppy"></cds-icon>
                  <span class="clr-icon-title">Speichern</span>
                </button>
              </clr-dg-cell>
            </clr-dg-row>

            <clr-dg-footer>
              <clr-dg-pagination #pagination [clrDgPageSize]="25">
                {{ pagination.firstItem + 1 }} - {{ pagination.lastItem + 1 }} von {{ staff.length }} Mitarbeiter(n)
              </clr-dg-pagination>
            </clr-dg-footer>
          </clr-datagrid>

          <app-edit-staff
            *ngIf="updating"
            [editStaff]="editStaffId"
            (updatedStaff)="onUpdated($event)">
          </app-edit-staff>

          <br />
          <a *ngIf="editMode && isAdmin" class="btn btn-primary btn-sm" (click)="editMode = false; updating = false; updateIndex = 999">Bearbeitung beenden</a>
          <a *ngIf="!editMode && isAdmin" class="btn btn-primary btn-sm" (click)="editMode = true">Mitarbeiter bearbeiten</a>
        </form>
      </div>
    </div>
  </div>
</main>
